// Widget Scripts
import headerButtons from './js/widgets/headerButtons.js';
import { initWidgetsHomepage } from './js/initWidgetsHomepage.js';

// Top Banner
import { topBanner } from './js/components/topBanner';

// Custom Theme Scripts
import './js/localjs.js';

// Theme Controller Scripts
import { themeController } from './js/themeController.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  themeController(themeData);

  headerButtons('headerButtons', headerButtonsOpts, 2);

  if (globalThis.location.pathname === '/') {
    initWidgetsHomepage();
  }

  topBanner();
});
